import { useEffect } from 'react'

/**
 * Locks body scrolling while a modal is open WITHOUT losing the scroll
 * position. html/body/#root are height:100% (globals.css), so a plain
 * `document.body.style.overflow = 'hidden'` collapses the document
 * scroller and the browser zeroes scrollY — the "close the video modal
 * and you're dumped back at the top of the page" bug. Save the offset
 * before locking and restore both on cleanup.
 *
 * Runs once per mount (empty deps) so a re-created onClose callback in
 * the caller can't unlock/relock mid-open.
 */
export function useBodyScrollLock() {
  useEffect(() => {
    const scrollY = window.scrollY
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prevOverflow
      window.scrollTo(0, scrollY)
    }
  }, [])
}
